import Link from "@/components/atsa/Link";
import { ThemeToggle } from "@modernatc/ui/theme-toggle";
import { AccountMenu } from "@/components/atsa/AccountMenu";
import { AtsaFooter } from "@/components/atsa/AtsaFooter";

const moduleLinks = [
  ["Memory", "/atsa/memory-differences"],
  ["Variables", "/atsa/value-assignments"],
  ["Spatial", "/atsa/spatial-awareness"],
  ["Radar", "/atsa/radar-simulation"],
  ["Personality", "/atsa/personality-assessment"],
  ["Reading", "/atsa/reading-comprehension"],
  ["Logic", "/atsa/logical-reasoning"],
  ["Full Mock", "/atsa/full-mock"],
] as const;

export function AppShell({ children, hideChrome = false }: { children: React.ReactNode; hideChrome?: boolean }) {
  if (hideChrome) return <>{children}</>;
  return (
    <div className="app-shell">
      <header className="site-header">
        <Link className="brand" href="/atsa">
          <ModernatcMark className="brand-mark" />
          <span>MODERN<span className="brand-accent">ATC</span></span>
        </Link>
        <nav className="nav-links" aria-label="Practice modules">
          {moduleLinks.map(([label, href]) => <Link key={href} href={href}>{label}</Link>)}
        </nav>
        <div className="header-actions">
          <ThemeToggle />
          <AccountMenu />
        </div>
      </header>
      <main className="page-wrap">{children}</main>
      <AtsaFooter />
    </div>
  );
}

// Matches the marketing-site logo mark (apps/web/components/nav.tsx).
function ModernatcMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="3.5" fill="currentColor" />
      <line x1="12" y1="2" x2="12" y2="5" stroke="currentColor" strokeWidth="1.5" />
      <line x1="12" y1="19" x2="12" y2="22" stroke="currentColor" strokeWidth="1.5" />
      <line x1="2" y1="12" x2="5" y2="12" stroke="currentColor" strokeWidth="1.5" />
      <line x1="19" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
